import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button, FormGroup, FormControl,
} from 'react-bootstrap';
import pick from 'lodash/pick';
import { bindActionCreators } from 'redux';
import s from '../../../../redux/selectors';
import a from '../../../../redux/actions';
import LocationAutocomplete from '../../../common/LocationAutocomplete.tsx';
import { wrap, withT, withRouterAndHelpers } from '../../../../lib/wrappers';
import types from '../../../../types';
import { CustomizableButton } from '../../../common/Customizable';

const Filters = ({
  t, leadersFilterForm, updateLeadersFilter, currentRoute,
  assignLeadersFilterForm, ui
}) => (
  <div id="leaders_filter__container">
    <FormGroup>
      <LocationAutocomplete
        placeholder={t('Select location')}
        identifier="leaderboardFilter"
        onLocationSelected={(locationSuggestion) => {
          assignLeadersFilterForm({ location: locationSuggestion });
        }}
      />
    </FormGroup>

    <FormGroup>
      <FormControl
        componentClass="select"
        value={leadersFilterForm.inputSize}
        onChange={e => assignLeadersFilterForm({ inputSize: e.target.value })}
      >
        <option value="">{t('Household size')}</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3 ({t('avg.')})</option>
        <option value="4">4</option>
        <option value="5">5+</option>
      </FormControl>
    </FormGroup>
    <CustomizableButton ui={ui} className="btn btn-success" onClick={() => updateLeadersFilter(currentRoute)}>{t('Apply')}</CustomizableButton>
  </div>
);

Filters.propTypes = {
  t: PropTypes.func.isRequired,
  updateLeadersFilter: PropTypes.func.isRequired,
  assignLeadersFilterForm: PropTypes.func.isRequired,
  leadersFilterForm: types.LeadersFilter.isRequired,
  currentRoute: PropTypes.string.isRequired,
  ui: PropTypes.any,
};

const mapStateToProps = (state, ownProps) => [
  'leadersFilterForm', 'ui',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'updateLeadersFilter',
    'assignLeadersFilterForm',
  ]),
  dispatch,
);

export default wrap(
  withT('leaders'),
  withRouterAndHelpers,
  connect(mapStateToProps, mapDispatchToProps)(Filters),
);
